/** ツール行に添える差分の増減行数 (+N / -N)。 */
export function DiffLineStats({ added, removed }: { added: number; removed: number }) {
	if (added === 0 && removed === 0) return null;
	return (
		<span className="shrink-0 font-mono text-caption">
			{added > 0 && <span className="text-diff-added-fg">{` +${added}`}</span>}
			{removed > 0 && <span className="text-diff-removed-fg">{` -${removed}`}</span>}
		</span>
	);
}
